<div class="relative flex min-w-xs flex-col gap-6 rounded-xl bg-white p-4 text-center shadow-lg">
  <p class="font-family-din text-text-primary font-medium">
    <ng-content></ng-content>
  </p>
  <rid-button content="Volgende" (click)="continue.emit()" />
</div>
